<template>
  <div>
    <div class="btn">
      <SettingSvg />
      <span v-on:click="showHideDialog(true)">设置</span>
    </div>
  <el-dialog ref="settingsDialog" :visible="showDialog" title="选项设置" center append-to-body>
    <el-form :model="form">
      <el-form-item label="模型" :label-width="formLabelWidth">
      <el-select v-model="form.model" placeholder="Please select a model">
        <el-option label="GPT3.5" value="GPT35" />
        <el-option label="GPT4" value="GPT4" />
      </el-select>
    </el-form-item>
    <el-form-item label="语言" :label-width="formLabelWidth">
      <el-select v-model="form.language" placeholder="Please select a language">
        <el-option label="中文" value="Chinese" />
        <el-option label="English" value="English" />
      </el-select>
    </el-form-item>
  </el-form>
  <template #footer>
      <span class="dialog-footer">
        <el-button @click="showHideDialog(false)">取消</el-button>
        <el-button type="primary" @click="showHideDialog(false)">确定</el-button>
      </span>
    </template>
  </el-dialog>
</div>
</template>
<script>
import SettingSvg from '@/assets/svg/setting.svg'

export default {
  components: { SettingSvg },
  data: () => ({
    form: {
      model: 'GPT3.5',
      language: '中文'
    },
    formLabelWidth: '140px',
    showDialog: false
  }),
  methods: {
    showHideDialog(visible) {
      console.log('showHideDialog', visible)
      this.showDialog = visible
    }
  }
}
</script>
<style scoped>
.btn {
    display: flex;
    align-items: center;
    margin-bottom: 1.13rem;

    span {
      padding-left: 0.4rem;
      font-size: 0.88rem;
    }
  }
.el-form {
  align-items: center;
}
.el-button--text {
margin-right: 15px;
}
.el-select {
width: 300px;
}
.el-input {
width: 300px;
}
.dialog-footer button:first-child {
  margin-right: 10px;
}
</style>
